import { render, staticRenderFns } from "./brochure.vue?vue&type=template&id=2ad6ad4a&scoped=true&"
import script from "./brochure.vue?vue&type=script&lang=js&"
export * from "./brochure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6ad4a",
  null
  
)

export default component.exports